import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import styles from './HostServiceList.module.css'
import { HostServiceCard } from '../HostServiceCard'
import { useState } from 'react'

export interface HostServiceListProps {
    hostServiceList?: any[]
    marketSpyId?: number
    loading?: boolean
}

export const HostServiceList = (props: HostServiceListProps): JSX.Element => {
    const {
        hostServiceList,
        marketSpyId,
        loading = false
    } = props

    const [openStartSpyHostServiceDialog, setOpenStartSpyHostServiceDialog] = useState<boolean>(false)
    const handleStartSpyHostService = () => {
        setOpenStartSpyHostServiceDialog(true)
    }

    const handleCloseStartSpyHostServiceDialog = () => {
        setOpenStartSpyHostServiceDialog(false)
    }
    const dataRender = () => {
        if (loading === true) {
            return (
                <Box sx={{ height: '300px' }}>
                    <CircularProgress
                        size={68}
                        sx={{
                            color: '#4caf50',
                        }}
                    />
                </Box>
            )
        }

        if (hostServiceList === undefined || hostServiceList.length === 0) return (
            <></>
        )

        return (
            <div
                className={styles.HostServiceList_Root}
            >
                {
                    hostServiceList?.map((hostService: any, index: number) => {
                        return (
                            <div key={hostService.id}>
                                <HostServiceCard
                                    hostServiceInformation={
                                            {
                                            ...hostService,
                                            ...{ hostRank: ++index }
                                            }
                                        }
                                    marketSpyId={marketSpyId}
                                    onStartSpyHostService={handleStartSpyHostService}
                                />
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    const dialogRender = () => {
        <Dialog
            open={openStartSpyHostServiceDialog}
            onClose={handleCloseStartSpyHostServiceDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" sx={{ fontSize: '24px', fontWeight: '600' }}>
                {"We will spy on this property"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" sx={{ fontSize: '20px' }}>
                    Once changes occur you will receive notification and the results will appear under Property Results
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseStartSpyHostServiceDialog} autoFocus>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    }

    return (
        <>           
            {
                dataRender()
            }
            {
                dialogRender()
            }
        </>
    )
}